import React from "react";
import Property from "../../component/Property";

const PropertyPage = () => {
  return (
    <div>
      <Property />
    </div>
  );
};

export default PropertyPage;
